import { Stack, Typography } from '@mui/material';

import { FileUploadButton } from '@common/components/FileUploadButton';

type Props = {
  label: string;
  subText: string;
  accept: string;
  onUploaded: (file: File) => void;
  disabled: boolean;
};

export const FileUploadButtonWithSubtext = ({
  label,
  subText,
  accept,
  disabled,
  onUploaded,
}: Props) => (
  <Stack alignItems='stretch' width='100%' gap={1}>
    <FileUploadButton onUploaded={onUploaded} accept={accept} label={label} disabled={disabled} />
    <Typography variant='caption' sx={{ display: 'block' }}>
      {subText}
    </Typography>
  </Stack>
);
